import { CSSObject } from '@chakra-ui/react';

export const TransactionsContainer: CSSObject = {
  mt: '1',
};
